(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('UserGuideController', UserGuideController);
      
  UserGuideController.$inject = [
    '$log', 
    '$scope',
    '$sce',
    'shell',  
    'localStorageService'
  ];
    
  function UserGuideController(
      $log, 
      $scope,
      $sce, 
      shell, 
      localStorageService
  ) {
    
    $log = $log.getInstance('UserGuideController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.shell = shell;
    vm.videos = []

    activate();
    
    function activate() {
      shell.setTitle('User Guide');
    }

    vm.guideLinks = [
      {
        title: 'Introduction',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIQXpxWU1id3lNZU0',
        description: ''
      },
      {
        title: 'Teaching Ideas',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIQS0zaHluSFIzVXc',
        description: ''
      },
      {
        title: 'How does it Work?',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIVEY0VlNJeW9lVVk',
        description: ''
      },
      {
        title: 'Quick Start Guide',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrISjEtRmExVU9UVGs',
        description: '(Read/Watch this if you just want to get started, though things make more sense if you go in order)'
      },
      {
        title: 'Using MARS like a Pro',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIVjVQcEhTOERtQlE',
        description: ''
      },
      {
        title: 'Using MARS for Marks',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIX1VoRDJtWUN5SjQ',
        description: ''
      },
      {
        title: 'Preparing for the Next Unit Offering',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIVUxEZDVCRHlnNDQ',
        description: ''
      },
      {
        title: 'Using the Leaderboard',
        href: 'https://drive.google.com/open?id=0B3jrsLjSGHrIUnh5WkNDd1VyWTg',
        description: ''
      },
    ]

    vm.videos = [
      {
        title: 'Introducing MARS!',
        description: 'A brief introduction to MARS, the Monash Audience ' +
        'Response System.',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/nOo9JDIG-cY')
      },
      {
        title: 'Teaching Ideas',
        description: 'Tips for Successful "Clicker" Use: ' +
        'http://casa.colorado.edu/~dduncan/clickers/Tips.pdf \n' +
        'Georgetown University Clickers Community of Practice: ' +
        'https://blogs.commons.georgetown.edu/clickers_cop/pedagogy/ \n' +
        'University of British Columbia Clicker Resources: ' +
        'http://www.cwsei.ubc.ca/resources/clickers.htm\n\n' +
        'Peer Instruction:\nhttps://www.youtube.com/watch?v=I_7L0tOl4v4\n' +
        'https://blog.peerinstruction.net \n\n' + 
        'Concept Inventories (scroll to the CLICKER QUESTION COLLECTIONS ' +
        'section): http://www.cwsei.ubc.ca/resources/clickers.htm',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/PCJ7i04WJps')
      },
      {
        title: 'How does it Work?',
        description: 'This video gives on overview on how MARS works and the ' +
        'way that polls are organised within it.\n\n This understanding ' +
        'will help lecturers to organise, collaborate and reuse their polls ' +
        'across semesters.',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/eoSx0mDvKC0')
      },
      {
        title: 'MARS Quick Start Guide',
        description: 'The MARS quick start guide. If you can\'t be ' +
        'bothered watching the other videos, make sure you watch this ' +
        'one! \n\n(Though everything will make more sense if you watch ' +
        'them in order)\n\nStudent Instructions Slide: ' +
        'https://drive.google.com/open?id=0B3jrsLjSGHrITkxONGtaTVZBbTg',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/eY9Vk2nBu5E?start=44')
      },
      {
        title: 'Use MARS Like a Pro!',
        description: 'A demonstration on the best way to use MARS in a lecture.',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/8ieGeDnXE4U')
      },
      {
        title: 'Using MARS for Marks',
        description: 'So you want to use MARS for participation marks?\n\n' +
        'This video shows you why you might want to, data on what happens ' +
        'if you do, how to do it and what issues you might encounter.\n\n' +
        'If you just want to know "how" to export data from MARS, skip ' +
        'to 3:38.\n\nThe reference provided in the video is ' +
        'http://doi.org/10.1073/pnas.1319030111',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/TCF8IuOzKMw')
      },
      {
        title: 'Preparing for the Next Unit Offering',
        description: 'This video shows how to prepare your collection for ' +
        'the next time you teach your unit.',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/SnMkJ9tvv5o')
      },
      {
        title: 'Using the Leaderboard',
        description: 'The MARS leaderboard function enables some basic ' +
        'gamification concepts, where students can have some friendly ' +
        'competition with each other while answering questions in MARS.\n\n' +
        'You could also use it for an activity such as "tournament" where ' +
        'students can answer many questions in a row over a set time period ' +
        'to highlight areas of focus for their test or exam revision.',
        url: $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/HpMC4rd7uOc')
      },
    ]
  }
  
})();